export default __webpack_public_path__ + "static/media/img-0611-monaco-full-face.14e627c4.png";